// ProjectDetail component - Project detail content
import React from 'react';
import detailImg from '../assets/images/resources/faq.png';

const ProjectDetail = () => {
  return (
    <section className="project-detail">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="project_detail_image" style={{ marginTop: '100px' }}> 
              <img
                src={detailImg}
                alt="Innovations de récolte"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="harvest_innovations_detail">
              <h2>INNOVATIONS DE RÉCOLTE</h2>
              <p>
                La récolte agricole est une étape cruciale de notre processus. Chez Leaders
                Agro Elite, nous utilisons des méthodes innovantes pour garantir une récolte
                abondante et de qualité supérieure. Nos experts surveillent attentivement
                chaque étape, de la maturation des cultures à la collecte, afin de maximiser
                le rendement et de préserver la fraîcheur des produits.
              </p>
              <p className="harvest_innovations_detail_bottom_text">
                Grâce à une combinaison de technologies modernes et de pratiques agricoles
                responsables, nous aidons nos partenaires à réduire les pertes post-récolte
                et à améliorer la traçabilité de leurs productions.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="project_challenges">
              <h2>DÉFIS DE LA RÉCOLTE</h2>
              <ul className="project_challenges_box list-unstyled">
                <li>
                  <div className="project_challenges_icon">
                    <span className="icon-plant"></span>
                  </div>
                  <div className="project_challenges_content">
                    <h4>OPTIMISATION DES RENDEMENTS AGRICOLES</h4>
                    <p>
                      Mise en place de stratégies de récolte adaptées à chaque parcelle afin
                      de réduire les pertes et de tirer le meilleur parti des cultures, tout
                      en préservant la qualité des produits.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="project_challenges_icon">
                    <span className="icon-farmer"></span>
                  </div>
                  <div className="project_challenges_content">
                    <h4>AMÉLIORATION DE LA QUALITÉ DES PRODUITS RÉCOLTÉS</h4>
                    <p>
                      Utilisation d’équipements modernes et de méthodes de récolte contrôlées
                      pour limiter les dommages sur les cultures, optimiser leur conservation
                      et garantir des produits sains et uniformes.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="harvest_innovations_detail_bottom_text">
              <p>
                Nous sommes déterminés à surmonter les défis liés à la récolte agricole en
                investissant continuellement dans la recherche et le développement de
                nouvelles technologies. En collaborant étroitement avec les agriculteurs,
                nous concevons des solutions sur mesure qui répondent à leurs besoins
                spécifiques et contribuent à la réussite de leurs exploitations. Notre
                objectif est d’assurer un équilibre durable entre performance, qualité et
                respect de l’environnement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetail;
